export function storePrefillEmail(email) {
  if (!email) {
    return;
  }
  try {
    sessionStorage.setItem("prefillEmail", email);
  } catch (err) {
    // best-effort — sessionStorage may be unavailable in some browsers
  }
}

export function navigateToLogin(navigate, email) {
  storePrefillEmail(email);
  navigate("/");
}

export function navigateToForgotUsername(navigate, email) {
  storePrefillEmail(email);
  navigate("/?action=forgot-username");
}
